import { Client } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { Me } from '@nrdy-marketing-engine/cart/@types/me';
import React from 'react';
import useUser from './use-user';

export interface UserContextInterface {
  clientID: string;
  convertUserAndStore?: () => Promise<void>;
  createUserAndStore?: (clientParams: Client) => Promise<void>;
  loading: boolean;
  refetchUserAndStore?: () => void;
  signInAndStore?: ({ email, password }: Partial<Client>) => Promise<any>;
  user: Me;
}

export const UserCtx = React.createContext<UserContextInterface | null>({
  clientID: null,
  user: null,
  loading: true,
});

export function UserProvider(props: {
  children: React.ReactNode;
  /** The userContext passed down from the server-side, if present, to skip further fetches */
  userContext?: UserContextInterface;
}) {
  const { children } = props;
  const userProps = useUser(props.userContext);

  return <UserCtx.Provider value={userProps}>{children}</UserCtx.Provider>;
}

// custom hook, main way of interaction with context
// largely for readability and making sure that you're not trying to use it without the expected provider
export const useUserContext = () => {
  const context = React.useContext(UserCtx);

  if (context === undefined) {
    throw new Error('useUserContext can only be used within an UserProvider');
  }

  return context;
};
